<template>
  <Teleport to="body">
    <!-- 레이어 팝업 렌더링 (variant='layer', dspType='2') -->
    <LayerPopup
        v-for="p in (popups || []).filter(item => item.variant === 'layer')"
        :key="p.popupId"
        v-model="state.vis[p.popupId]"
        :popup="p"
    />
    <!-- 윈도우 팝업 렌더링 (variant='window', dspType='1', window.open으로 처리) -->
    <WindowPopup
        v-for="p in (popups || []).filter(item => item.variant === 'window')"
        :key="p.popupId"
        v-model="state.vis[p.popupId]"
        :popup="p"
    />
  </Teleport>
</template>
<script setup>
import { reactive, watch } from 'vue'
import { useRoute } from 'vue-router'
import LayerPopup from './LayerPopup.vue'
import WindowPopup from './WindowPopup.vue'

const route = useRoute()

const props = defineProps({
  /** [{ popupId, variant, contentHtml, title, left, top, zIndex, stopVewAt:'Y'|'N', expireDays:number, visible:boolean }] */
  popups: { type: Array, default: () => [] },
})

/** 개별 팝업 표시 상태를 v-model로 관리 */
const state = reactive({ vis: {} })

// 페이지 이동 시 레이어 팝업만 닫기 (윈도우 팝업은 유지)
watch(() => route.path, () => {
  const layerIds = (props.popups || [])
    .filter(p => p.variant === 'layer')
    .map(p => p.popupId)
  layerIds.forEach(id => {
    state.vis[id] = false
  })
})

// 팝업 목록 변경 시 상태 재초기화
// - 메뉴 변경 → 팝업 목록 새로 로드 → state.vis 초기화 → 팝업 자동 닫힘
// - 다시 메뉴 돌아옴 → 팝업 목록 다시 로드 → state.vis 초기화 → 팝업 다시 열림 (쿠키 제외)
watch(() => props.popups, (list) => {
  // 1. 이전 state.vis에서 현재 popups에 없는 팝업 제거
  Object.keys(state.vis).forEach(key => {
    if (!(list || []).find(p => p.popupId === key)) {
      delete state.vis[key]
    }
  })
  
  // 2. 새로운 팝업들을 visible 상태로 (re)초기화
  ;(list || []).forEach(p => {
    state.vis[p.popupId] = !!p.visible
  })
}, { immediate: true, deep: true })
</script>
